import React, { useEffect, useState } from "react";
import styled from "styled-components";
import {
  SetMenuGroupType,
  pickGroupListType,
  setMenuListType,
  setMenuOptionGrupType,
  setMenuType,
} from "../../../controller/StoreController";
import { LANG_JP, LANG_KO, langState, langText } from "../../../recoil/lang";
import {
  getOptionName,
  getOptionTypeName,
  getPrdName,
  getPrdTypeName,
} from "../../../utils/util";
import { useToast } from "../../../controller/ToastController";
import { useRecoilState } from "recoil";

interface SetProps {
  setMenuGroup: SetMenuGroupType | undefined;
  selectedOption: number[][];
  setSelectedOption: ([]) => void;
  pick: pickGroupListType[];
  setPick: (pick: pickGroupListType[]) => void;
}

const checkOption = (data: number[][]) => {
  return data.some((array) => array.length > 0) ? (
    <div className="optionLine"></div>
  ) : (
    ""
  );
};

// 세트메뉴 선택 메뉴, 옵션
const RenderSetMenuSelectList = (oProps: any) => {
  const setPick: pickGroupListType[] = oProps.pick;
  const pickArray = setPick.map(({ pick }) => pick);
  const inputMin: any = setPick.map(({ input_min }) => input_min);

  return (
    <div className="selectListWrap">
      {pickArray.map((product, index) => {
        return (
          <div key={index}>
            <div className="listWrap">
              {inputMin[index] > 0 ? (
                <h2 className="listTitle">
                  {langText.setOptionModal_configuration[oProps.lang]}
                  {index + 1}
                  {" - "}
                  <span className="required">
                    ({langText.optionModal_title_Required[oProps.lang]})
                  </span>
                </h2>
              ) : (
                <>
                  <h2 className="listTitle">
                    {langText.setOptionModal_addtional[oProps.lang]}
                    {" - "}
                    <span className="option">
                      ({langText.setOptionModal_option[oProps.lang]})
                    </span>
                  </h2>
                </>
              )}
              <div className="listItem">
                {product.length === 0 && (
                  <div className="selectMenuWrap">
                    <h3>
                      {oProps.lang === LANG_KO || oProps.lang === LANG_JP
                        ? `[${getPrdTypeName(setPick[index], oProps.lang)}] `
                        : ""}
                      {langText.setOptionModal_select_menu[oProps.lang]}
                      {oProps.lang !== LANG_KO && oProps.lang !== LANG_JP
                        ? ` [${getPrdTypeName(setPick[index], oProps.lang)}]`
                        : ""}
                    </h3>
                  </div>
                )}
                {product.length > 0 &&
                  product.map((renderProduct, index) => {
                    return (
                      <div key={index} className="selectMenuWrap">
                        <div className="selectMenu">
                          <h3>{getPrdName(renderProduct, oProps.lang)}</h3>
                          <h2>{checkOption(renderProduct.pick)}</h2>
                          {renderProduct.pick.map((oPtion, optGroupIdx) => {
                            return (
                              <>
                                <div className="selectOptionWrap">
                                  {oPtion.map((optionIdx) => {
                                    return (
                                      <>
                                        <h3>
                                          {getOptionName(
                                            renderProduct.option_group_list[
                                              optGroupIdx
                                            ].option_list[optionIdx],
                                            oProps.lang
                                          )}
                                        </h3>
                                      </>
                                    );
                                  })}
                                </div>
                                {optGroupIdx !==
                                  renderProduct.pick.length - 1 &&
                                  oPtion.length > 0 && <h3>{",  "}</h3>}
                              </>
                            );
                          })}
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
const RenderSetMenu = (oProps: any) => {
  const showToast = useToast();
  const [selectedTab, setSelectedTab] = useState(0);
  //세트메뉴 전체 정보
  const setMenuGroup: SetMenuGroupType = oProps.setMenuGroup;
  //tab정보(메뉴그룹)
  const setMenuTabList: setMenuListType[] = setMenuGroup.set_prd_type_list;
  //선택된 tab정보(메뉴그룹)
  const selectedProductType: setMenuListType = setMenuTabList[selectedTab];
  //선택된 메뉴그룹의 메뉴
  const setMenu: setMenuType[] = selectedProductType?.product_list || [];
  //메뉴그룹안에서 선택된 메뉴
  const [selectedMenus, setSelectedMenus] = useState<number[]>(
    Array(setMenuTabList.length).fill(null)
  );
  //메뉴그룹안에서 선택된 메뉴의 선택개수정보
  const { input_max, input_min } = setMenuTabList[selectedTab];

  //옵션그룹의 전체옵션
  const setMenuTotalOption: any = setMenu.map((data) => data.option_group_list);

  // 메뉴그룹 tab선택
  const handleTabClick = (index: number) => {
    setSelectedTab(index);
  };
  //메뉴그룹의 메뉴 선택
  const handleSetMenuClick = (selectedTab: number, index: number) => {
    const pick: pickGroupListType[] = [...oProps.pick];
    const productGroup = setMenuGroup.set_prd_type_list[selectedTab];
    const product = productGroup.product_list[index];
    const findIndex = pick[selectedTab].pick.findIndex(
      (obj) => obj.prd_id === product.prd_id
    );

    //TODO 담기
    if (findIndex === -1) {
      if (
        pick[selectedTab].input_min === 1 &&
        pick[selectedTab].input_max === 1
      ) {
        // 라디오일때
        pick[selectedTab].pick = [
          {
            ...product,
            pick: Array.from(
              { length: product.option_group_list.length },
              () => []
            ),
          },
        ];
      } else if (pick[selectedTab].pick.length >= pick[selectedTab].input_max) {
        showToast(
          `${langText.optionModal_title_Maximum[oProps.lang]} ${
            pick[selectedTab].input_max
          } ${langText.title_detail_count[oProps.lang]}${
            langText.setOptionModal_maximum_count[oProps.lang]
          }`,
          "error"
        );
      } else {
        pick[selectedTab].pick.push({
          ...product,
          pick: Array.from(
            { length: product.option_group_list.length },
            () => []
          ),
        });
      }
    } else {
      if (
        pick[selectedTab].input_min === 1 &&
        pick[selectedTab].input_max === 1
      ) {
        // 라디오일때
      } else {
        pick[selectedTab].pick.splice(findIndex, 1);
      }
    }
    oProps.setPick(pick);
  };
  const handleOptionClick = (
    selectedTab: number,
    product_index: number,
    option_group_index: number,
    index: number
  ) => {
    const pick: pickGroupListType[] = [...oProps.pick];
    const pickOptionGroup =
      pick[selectedTab].product_list[product_index].option_group_list[
        option_group_index
      ];

    const productGroup = setMenuGroup.set_prd_type_list[selectedTab];
    const product = productGroup.product_list[product_index];
    const optionGroup = product.option_group_list[option_group_index];
    const option = optionGroup.option_list[index];

    const pickProductIndex = pick[selectedTab].pick.findIndex(
      (obj) => obj.prd_id === product.prd_id
    );

    const pickOptionIndex = pick[selectedTab].pick[pickProductIndex].pick[
      option_group_index
    ].findIndex((idx) => idx === index);

    if (pickOptionIndex === -1) {
      if (
        pickOptionGroup.option_input_min === 1 &&
        pickOptionGroup.option_input_max === 1
      ) {
        //라디오일경우
        pick[selectedTab].pick[pickProductIndex].pick[option_group_index] = [
          index,
        ];
      } else if (
        pick[selectedTab].pick[pickProductIndex].pick[option_group_index]
          .length >= pickOptionGroup.option_input_max
      ) {
        showToast(
          `${langText.optionModal_title_Maximum[oProps.lang]} ${
            pick[selectedTab].input_max
          } ${langText.setOptionModal_maximum_count[oProps.lang]}`,
          "error"
        );
      } else {
        pick[selectedTab].pick[pickProductIndex].pick[option_group_index].push(
          index
        );
      }
    } else {
      if (
        pickOptionGroup.option_input_min === 1 &&
        pickOptionGroup.option_input_max === 1
      ) {
        // 라디오일때
      } else {
        pick[selectedTab].pick[pickProductIndex].pick[
          option_group_index
        ].splice(pickOptionIndex, 1);
        // pick[selectedTab].pick.splice(findIndex, 1);
      }
    }

    oProps.setPick(pick);

    console.log(
      "옵션클릭:",
      setMenuGroup.set_prd_type_list[selectedTab].product_list[product_index]
        .option_group_list[option_group_index].option_list[index]
    );
  };

  return (
    <>
      {/* setMenuTab */}
      <div className="tabContainer">
        {setMenuTabList.map((productType, index) => (
          <div
            key={productType.prd_type_id}
            className={`tab ${selectedTab === index ? "active" : ""}`}
            onClick={() => handleTabClick(index)}
          >
            <div className="tabButton">
              {productType.input_min > 0 ? (
                <>
                  <h2>
                    {langText.setOptionModal_configuration[oProps.lang]}
                    {index + 1}
                  </h2>
                  <img
                    className="backButton"
                    src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_require.svg`}
                    alt="필수"
                  />
                </>
              ) : (
                <h2>{langText.setOptionModal_addtional[oProps.lang]}</h2>
              )}
            </div>
          </div>
        ))}
      </div>
      <div className="optionListWrap">
        {/* setMenu */}
        <div className="setMenuWrap">
          <div className="menuTitle">
            <h1>{getPrdTypeName(setMenuTabList[selectedTab], oProps.lang)}</h1>
            {input_min > 0 && input_min === input_max && (
              <h2>
                ({langText.optionModal_title_Required[oProps.lang]} {input_min}
                {langText.title_detail_count[oProps.lang]})
              </h2>
            )}
            {input_min > 0 && input_min !== input_max && (
              <h2>
                ({langText.optionModal_title_Required[oProps.lang]} {input_min}
                {langText.title_detail_count[oProps.lang]})
                <span>
                  ({langText.optionModal_title_Maximum[oProps.lang]} {input_max}
                  {langText.title_detail_count[oProps.lang]})
                </span>
              </h2>
            )}
            {input_min === 0 && (
              <span>
                ({langText.optionModal_title_Maximum[oProps.lang]} {input_max}
                {langText.title_detail_count[oProps.lang]})
              </span>
            )}
          </div>
          <div className="setMenuInfoWrap">
            {setMenu.map((menu, index) => {
              const { prd_id, prd_name, prd_price, is_soldout } = menu;
              const isSelected =
                oProps.pick[selectedTab].pick.findIndex(
                  (obj: any) => obj.prd_id === prd_id
                ) !== -1;

              const handleClick = () => {
                if (is_soldout === 0) {
                  handleSetMenuClick(selectedTab, index);
                }
              };
              return (
                <div
                  className={`setMenuInfo ${isSelected ? "selected" : ""} ${
                    is_soldout === 1 ? "sold" : ""
                  }`}
                  key={prd_id}
                  onClick={handleClick}
                >
                  <h3>{getPrdName(menu, oProps.lang)}</h3>
                  <h4>{prd_price}원</h4>
                  {is_soldout === 1 && (
                    <div className="soldText">
                      <h2>SOLD OUT</h2>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
          {/* setMenuOption */}
          <div className="menuOptionWrap">
            {setMenu.map((menu, product_index) => (
              <div key={menu.prd_id}>
                {menu.option_group_list.length > 0 && (
                  <div>
                    {oProps.pick[selectedTab].pick.findIndex(
                      (obj: any) => obj.prd_id === menu.prd_id
                    ) !== -1 && (
                      <div className="optionName">
                        <h3>
                          {getPrdName(menu, oProps.lang)}
                          {langText.setOptionModal_select_option[oProps.lang]}
                        </h3>
                      </div>
                    )}
                    {
                      <>
                        {menu.option_group_list.map(
                          (
                            optionGroup: setMenuOptionGrupType,
                            option_group_index: number
                          ) => {
                            const pick: pickGroupListType[] = oProps.pick;
                            const pickProductIndex = pick[
                              selectedTab
                            ].pick.findIndex(
                              (obj: any) => obj.prd_id === menu.prd_id
                            );
                            if (
                              oProps.pick[selectedTab].pick.findIndex(
                                (obj: any) => obj.prd_id === menu.prd_id
                              ) === -1
                            ) {
                              return <></>;
                            } else {
                              return (
                                <>
                                  <div key={optionGroup.option_type_id}>
                                    <div className="menuOptionTitle">
                                      <h2>
                                        {getOptionTypeName(
                                          optionGroup,
                                          oProps.lang
                                        )}
                                      </h2>
                                      <span>
                                        (
                                        {
                                          langText.optionModal_title_Required[
                                            oProps.lang
                                          ]
                                        }
                                        {optionGroup.option_input_min}
                                        {
                                          langText.title_detail_count[
                                            oProps.lang
                                          ]
                                        }
                                        )
                                        {optionGroup.option_input_max !=
                                        optionGroup.option_input_min
                                          ? `(${
                                              langText
                                                .optionModal_title_Maximum[
                                                oProps.lang
                                              ]
                                            } ${optionGroup.option_input_max}${
                                              langText.title_detail_count[
                                                oProps.lang
                                              ]
                                            })`
                                          : ""}
                                      </span>
                                    </div>
                                    <div className="optionGroupWrap">
                                      {optionGroup.option_list.map(
                                        (option: any, index: number) => (
                                          <div
                                            className={`optionGroup ${
                                              pickProductIndex !== -1 &&
                                              pick[selectedTab].pick[
                                                pickProductIndex
                                              ].pick[
                                                option_group_index
                                              ].includes(index)
                                                ? "active"
                                                : ""
                                            }`}
                                            onClick={() => {
                                              handleOptionClick(
                                                selectedTab,
                                                product_index,
                                                option_group_index,
                                                index
                                              );
                                              console.log(
                                                pickProductIndex,
                                                option_group_index
                                              );
                                            }}
                                            key={index}
                                          >
                                            <h2>
                                              {getOptionName(
                                                option,
                                                oProps.lang
                                              )}
                                            </h2>
                                            <p>{option.option_price}원</p>
                                          </div>
                                        )
                                      )}
                                    </div>
                                  </div>
                                </>
                              );
                            }
                          }
                        )}
                      </>
                    }
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

const SetOptionList = ({
  setMenuGroup,
  selectedOption,
  setSelectedOption,
  pick,
  setPick,
}: SetProps) => {
  const [lang, setLang] = useRecoilState<number>(langState);
  const [selectedItems, setSelectedItems] = useState([]);

  useEffect(() => {
    console.log(pick);
  }, [pick]);

  useEffect(() => {
    if (setMenuGroup) {
      const pickGroupList: pickGroupListType[] = [];
      for (let i = 0; i < setMenuGroup.set_prd_type_list.length; i++) {
        const productGroup = setMenuGroup.set_prd_type_list[i];
        if (
          productGroup.input_min === 1 &&
          productGroup.input_max === 1 &&
          productGroup.product_list.length > 0
        ) {
          let productInitPick: pickGroupListType = {
            ...productGroup,
            pick: [
              {
                ...productGroup.product_list[0],
                pick: Array.from(
                  {
                    length:
                      productGroup.product_list[0].option_group_list.length,
                  },
                  () => []
                ),
              },
            ],
          };
          pickGroupList.push(productInitPick);
        } else {
          pickGroupList.push({
            ...productGroup,
            pick: [],
          });
        }
      }
      console.log("pickGroupList", pickGroupList);

      setPick(pickGroupList);
    }
  }, [setMenuGroup]);

  return (
    <Style>
      <>
        <RenderSetMenuSelectList
          pick={pick}
          lang={lang}
          setMenuGroup={setMenuGroup}
        />
        {pick.length > 0 && (
          <RenderSetMenu
            setMenuGroup={setMenuGroup}
            selectedOption={selectedOption}
            setSelectedOption={setSelectedOption}
            lang={lang}
            selectedItems={selectedItems}
            setSelectedItems={setSelectedItems}
            pick={pick}
            setPick={setPick}
          />
        )}
      </>
    </Style>
  );
};

export default SetOptionList;

const Style = styled.div`
  /* selectListWrap */
  .selectListWrap {
    margin-top: 10px;
    background: #232323;
    min-height: 100px;
    overflow-y: auto;
    padding: 10px 20px;
    border-top: 1px solid #555555;
    border-bottom: 1px solid #555555;
  }
  .listWrap {
    display: flex;

    .listTitle {
      font-size: 14px;
      line-height: 20px;
      font-weight: 400;
      color: #e5e5e5;
      margin-bottom: 8px;

      .required,
      .option {
        font-size: 12px;
        line-height: 12px;
        font-weight: 500;
        color: #ff4a4a;
      }
      .option {
        color: #4dd2ae;
      }
    }
    .listItem {
      flex: 1;
      display: flex;
      flex-wrap: wrap;
    }
  }
  .selectMenuWrap {
    margin-left: 4px;
    margin-bottom: 4px;

    h3 {
      font-size: 14px;
      line-height: 20px;
      font-weight: 400;
      color: #e5e5e5;
    }
    .selectMenu {
      border: 1px solid #e5e5e5;
      padding: 1px 8px;
      border-radius: 3px;
      display: inline-flex;
      align-items: center;
    }
    .selectOptionWrap {
      display: flex;
      gap: 4px;
    }
    .optionLine {
      border-left: 1px solid #d9d9d9;
      margin: 0 6px;
      height: 14px;
    }

    .optionListWrap {
      flex: 1;
      padding: 0 10px;
      overflow-y: auto;
    }
  }

  /* tabContainer */
  .tabContainer {
    width: 100%;
    margin: 16px 0;
    padding: 0 10px;
    display: flex;
    align-items: center;
    overflow-x: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;

    h2 {
      font-size: 16px;
      line-height: 20px;
      font-weight: 500;
      color: #fff;
      white-space: nowrap;
      text-align: center;
    }
    .tab {
      min-width: 140px;
      width: 100%;
      padding: 8px;
      border-bottom: 1px solid #4dd2ae;
      text-align: center;
      cursor: pointer;
    }
    .tab.active {
      border: 1px solid #4dd2ae;
      border-bottom: 2px solid #000000;
      border-top-right-radius: 5px;
      border-top-left-radius: 5px;
      h2 {
        color: #4dd2ae;
      }
    }
    .tabButton {
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        margin-left: 4px;
      }
    }
  }
  .tabContainer::-webkit-scrollbar {
    display: none;
  }

  /* 메뉴 */
  .setMenuWrap {
    .menuTitle {
      display: flex;
      margin-bottom: 6px;

      h1,
      h2 {
        font-size: 14px;
        font-weight: 400;
        color: #e5e5e5;
      }
      h2,
      span {
        font-size: 12px;
        line-height: 16px;
        margin-left: 4px;
        color: #d14848;
      }
      span {
        font-size: 12px;
        color: #327ad0;
      }
    }
  }
  .setMenuInfoWrap {
    display: flex;
    gap: 8px;
    overflow-x: auto;
    margin-bottom: 20px;
    cursor: pointer;

    .setMenuInfo {
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      width: 30%;
      min-width: 110px;
      margin-bottom: 10px;
      padding: 10px 6px;
      border: 1px solid #fff;
      border-radius: 5px;
      background: #343434;
      gap: 20px;

      h3 {
        font-size: 16px;
        font-weight: 600;
      }
      h4 {
        font-size: 14px;
        font-weight: 600;
      }
    }
    .soldText {
      width: 100%;
      height: 100%;
      background: #00000066;
      border-radius: 8px;
      position: absolute;
      top: 0;
      right: 0;
      display: flex;
      align-items: center;
      justify-content: center;

      h2 {
        font-size: 18px;
        font-weight: 600;
        text-align: center;
        color: #fff;
      }
    }
    .setMenuInfo.selected {
      background: #40977f;
    }
  }

  /* 옵션 */
  .menuOptionWrap {
    width: 100%;

    .menuOptionTitle {
      display: flex;
      align-items: center;
      gap: 6px;

      h2 {
        font-size: 14px;
        font-weight: 400;
      }
      span {
        font-size: 12px;
        line-height: 12px;
        font-weight: 400;
        color: #d14848;
      }
    }
  }
  .optionName {
    width: 100%;
    margin-bottom: 20px;
    border-top: 1px solid #555555;

    h3 {
      display: inline-block;
      padding: 4px 14px;
      background: #575757;
      color: #fff;
      font-size: 14px;
      font-weight: 400;
      border-bottom-right-radius: 5px;
      border-bottom-left-radius: 5px;
    }
  }
  .optionGroupWrap {
    display: flex;
    margin-top: 10px;
    margin-bottom: 20px;
    overflow-x: auto;
    gap: 8px;

    .optionGroup {
      width: 30%;
      min-width: 90px;
      padding: 10px 6px;
      display: flex;
      align-items: stretch;
      justify-content: space-between;
      flex-direction: column;
      border: 1px solid #e5e5e5;
      border-radius: 5px;
      gap: 20px;
      cursor: pointer;

      h2 {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
        -webkit-line-clamp: 2;
        text-overflow: ellipsis;
      }
      h2,
      p {
        font-size: 13px;
        font-weight: 400;
        padding: 0;
        color: #fff;
      }
    }
    .optionGroup.active {
      background: #296252;
    }
  }
`;
